import { styled } from '@linaria/react'
import { ButtonSC } from 'atoms/Button'
import { INDENTS, MEDIA } from 'vars/index'
import { ButtonGroup } from '../ButtonGroup'
import { Wrapper as ButtonGroupWrapper } from '../ButtonGroup.styled'

export const ButtonGroupSubscriptionStatusSC = styled(ButtonGroup)`
  &${ButtonGroupWrapper} {
    width: 100%;
  }

  &${ButtonGroupWrapper} > ${ButtonSC}[data-arcana-button='true'] {
    width: 100%;
  }

  ${MEDIA.MIN_600} {
    &${ButtonGroupWrapper} {
      flex-wrap: nowrap;
    }

    &${ButtonGroupWrapper} > ${ButtonSC}[data-arcana-button='true'] {
      width: calc((100% - var(${INDENTS.INDENT_30})) / 2);
      height: 48px;
    }
  }

  ${MEDIA.MIN_768} {
    &${ButtonGroupWrapper} {
      width: auto;
    }

    &${ButtonGroupWrapper} > ${ButtonSC}[data-arcana-button='true'] {
      width: 240px;
    }
  }
`
